<template>
<div>
     <v-card>
    <v-card-title>
       All Refurbishers
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-btn class='info' small style='margin-top : 15px; margin-right : 15px' @click='dialog = true'>Add Refurbisher</v-btn>
        <v-btn small style='margin-top : 15px; margin-right : 15px' @click='downloadCSV'>Download CSV</v-btn>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-model='selected'
        
      :headers="headers"
      :items="refurb"
      :search="search">
<template v-slot:item.id="{item }" >
       <a  style='text-decoration: underline;' @click='showDetail(item)'>{{item.id}}</a>
    </template>
    <template v-slot:item.ngoData="{item }" >
      {{item.ngoData.length}}
    </template>
    </v-data-table>
  </v-card>

 <v-dialog
      v-model="transferDialog"
      
      max-width="390"
    >
      <v-card>
        <v-card-title class="headline">
         Transfer Refurbisher
        </v-card-title>
        <v-card-text>
           <v-select
                persistent-hint
          v-model="selectedTransferRefurbisher"
          :items="refurb"
          item-text="name"
          item-value="id"
          label="Select a Refurbisher"
          return-object
        ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="transferDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="transferRefurbisher()"
          >
            Transfer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  <v-dialog
      v-model="detailDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="detailDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Detail for {{selectedRefurbisher.name}}</v-toolbar-title>
            <v-spacer></v-spacer>
           <h2 v-if='selectedRefurbisher.disabled' class='red--text'>This account is disabled</h2>
          <v-spacer></v-spacer>
        
          <v-toolbar-items>
            <v-btn
             :disabled='selectedRefurbisher.disabled'
              dark
              text
              @click="saveData()"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list
          three-line
          subheader
        >
          <v-subheader>Refurbisher Infomation</v-subheader>
          <v-row class='ma-5'>
              
              <v-col
                cols="4"
              >
                <v-text-field
                :disabled='selectedRefurbisher.disabled'
                v-model='selectedRefurbisher.name'
                  label="Company Name*"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :disabled='true'
                 v-model='selectedRefurbisher.email'
                  label="Contact Email* (this will also be your login username)"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                :disabled='selectedRefurbisher.disabled'
                 v-model='selectedRefurbisher.address'
                 :rules="[v => !!v || 'Item is required']"
                 required
                label="Address"
                ></v-text-field>
              </v-col>
            </v-row>
        </v-list>
        <v-divider></v-divider>
       <v-subheader class='red--text'>Danger Zone</v-subheader>
       <v-btn :disabled='selectedRefurbisher.disabled' :loading='disableBtnLoading' @click='disabledAccounts' class='warning ma-5'>Disable All Accounts</v-btn>
         <v-divider></v-divider>
          <v-subheader>Partner NPO</v-subheader>
 <v-row >
   <v-col  v-for='(item,index) in selectedRefurbisher.ngoData' :key='index'
              md='3'  cols="12"
              >
           <v-card
           class='ma-5'
           elevation="5"
   
  >
    <v-card-text>
     <p>ID :{{item.id}}</p>
      <p class="display-1 text--primary">
        {{item.name}}
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn
      :disabled='selectedRefurbisher.disabled'
        @click="transferDialog = true; selectedNGO = item"
      >
       Transfer Refurbisher
      </v-btn>
    </v-card-actions>

  </v-card>
   </v-col>
 </v-row>

      </v-card>
    </v-dialog>



  <v-dialog
      v-model="dialog"
      max-width="600px"
    >
      <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
      <v-card>
        <v-card-title>
          <span class="headline">Add Refurbisher</span>
        </v-card-title>
        <v-card-text>
          
          <v-container>
            <v-row>
              
              <v-col
                cols="12"
              >
                <v-text-field
                v-model='createRefurbisher.name'
                  label="Company Name*"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                 v-model='createRefurbisher.email'
                  label="Contact Email* (this will also be your login username)"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                 v-model='createRefurbisher.address'
                 :rules="[v => !!v || 'Item is required']"
                 required
                label="Address"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addRefurbisher()"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
</div>
</template>

<script>
import shortid from 'shortid';
import papa from 'papaparse';
const fb = require("../../firebaseconfig");
export default {
      data(){
         return{
           disableBtnLoading : false,
           selectedNGO : null,
           valid : true,
            createRefurbisher : {
              disabled: false,
              id : shortid.generate(),
              name : null,
              address : null,
              email : null,
              ngoData : [],
              nonprofitsId : [],
              accounts : [],
            },
            selectedTransferRefurbisher : null,
            selectedRefurbisher : {
              id : null,
              name : null,
              address : null,
              email : null,
              ngoData : [],
              nonprofitsId : []
            },
            transferDialog : false,
            detailDialog  :false,
            dialog : false,
            selected : [],
            headers : [

               { text: 'ID',value: 'id'},
                              { text: 'Name',value: 'name'},
              { text: '# of Partner NPO',value: 'ngoData'},
            ],
            search : null,
            donations : null,
            ngo : [],
            refurb : [],
         }
      },
      async mounted() {
   await this.getRefurbishers();

  },
  methods : {
    async saveData(){
      await fb.db.collection("refurb").doc(this.selectedRefurbisher.id).update({
        name : this.selectedRefurbisher.name,
        address : this.selectedRefurbisher.address
      })
      this.detailDialog = false
    },
    async transferRefurbisher(){
      //this.selectedRefurbisher.id  
      //this.selectedNGO
      //this.selectedTransferRefurbisher.id
      //this.selectedNGO.id
      await fb.db.collection("refurb").doc(this.selectedRefurbisher.id).update({
         nonprofitsId : fb.firestore.FieldValue.arrayRemove(this.selectedNGO.id),
         ngoData : fb.firestore.FieldValue.arrayRemove(this.selectedNGO)
      });
      await fb.db.collection("refurb").doc(this.selectedTransferRefurbisher.id).update({
         nonprofitsId : fb.firestore.FieldValue.arrayUnion(this.selectedNGO.id),
         ngoData : fb.firestore.FieldValue.arrayUnion(this.selectedNGO)
      });
      await fb.db.collection("ngo").doc(this.selectedNGO.id).update({
        refurb : this.selectedTransferRefurbisher.id
      })
      fb.db.collection("donations").where("ngo","==",this.selectedNGO.id).get().then(docs =>{
        docs.forEach(doc=>{
          fb.db.collection("donations").doc(doc.id).update({
            refurbisherId : this.selectedTransferRefurbisher.id
          })
        })
      })

        fb.db.collection("assets").where("ngoId","==",this.selectedNGO.id).get().then(docs =>{
        docs.forEach(doc=>{
          fb.db.collection("assets").doc(doc.id).update({
            refurbisher : this.selectedTransferRefurbisher.id
          })
        })
      })

              this.$axios.post('https://us-central1-donorconnection-df169.cloudfunctions.net/adminapi/transferRefurbisher', {
               to : this.selectedTransferRefurbisher.id,
               npo : this.selectedNGO.id
            }, { headers: { "Content-Type": "application/json" } }).then(() => {
                this.transferDialog = false;
            })

      
    },
    showDetail(item){
      this.selectedRefurbisher = item;
      this.detailDialog = true
    },
    async addRefurbisher(){
      this.valid = this.$refs.form.validate()
      if(this.valid){
                    let exist = await this.$axios.post('https://us-central1-donorconnection-df169.cloudfunctions.net/adminapi/validateEmail', {
               email : this.createRefurbisher.email
            }, { headers: { "Content-Type": "application/json" } })
            if(exist.data === false){
              this.createRefurbisher.accounts = [this.createRefurbisher.email]
              await fb.db.collection("refurb").doc(this.createRefurbisher.id).set(this.createRefurbisher);
              await fb.db.collection("admin").doc("counter").update({
                totalRefurbisher : fb.firestore.FieldValue.increment(1),
              })
              this.dialog = false;
               }else{
                
                  alert("email already exist");
                  this.dialog = false;
               }

     
      }

    },
    disabledAccounts(){
      this.disableBtnLoading = true;
         this.$axios.post('https://us-central1-donorconnection-df169.cloudfunctions.net/adminapi/disableAccounts', {
               refurbisher : this.selectedRefurbisher.id,
               type : "refurb"
            }, { headers: { "Content-Type": "application/json" } }).then(() => {
              this.disableBtnLoading = false;
              this.detailDialog = false;
              fb.db.collection("refurb").doc(this.selectedRefurbisher.id).update({disabled : true});
            })
    },
    downloadCSV(){
      let csv = papa.unparse(this.refurb);
      var csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    var csvURL =  null;
    if (navigator.msSaveBlob)
    {
        csvURL = navigator.msSaveBlob(csvData, 'download.csv');
    }
    else
    {
        csvURL = window.URL.createObjectURL(csvData);
    }

    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', 'download.csv');
    tempLink.click();
    },
    goTo(item){
      this.$router.push("/donations/"+item.id);
    },


     async getRefurbishers(){
        await fb.db.collection("refurb").onSnapshot((query) => {
           this.refurb = [];
           query.forEach(ngo => {
         this.refurb.push(ngo.data())
        })
        });
        
     }
  }
}
</script>